var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 75C58.2107 75 75 58.2107 75 37.5C75 16.7893 58.2107 0 37.5 0C16.7893 0 0 16.7893 0 37.5C0 58.2107 16.7893 75 37.5 75ZM16.6667 58.349H28.0303V46.9854H16.6667V58.349ZM31.8182 58.349V46.9854H43.1818V58.349H31.8182ZM46.9697 46.9854H58.3333V58.349H46.9697V46.9854ZM24.2424 31.8339H35.6061V43.1975H24.2424V31.8339ZM39.3939 31.8339H50.7576V43.1975H39.3939V31.8339ZM56.3846 27.5185C56.5195 28.0013 56.4575 28.5179 56.2121 28.9551L56.2083 28.9626C56.0887 29.1808 55.9273 29.3733 55.7334 29.5291C55.5394 29.6848 55.3166 29.8009 55.0777 29.8705C54.8389 29.9402 54.5887 29.9621 54.3413 29.935C54.094 29.9079 53.8545 29.8323 53.6364 29.7126L37.5 20.7354L21.4015 29.6748C20.9671 29.889 20.4672 29.9286 20.0044 29.7856C19.5417 29.6425 19.1514 29.3276 18.9137 28.9056C18.676 28.4835 18.609 27.9865 18.7265 27.5166C18.844 27.0468 19.1371 26.6398 19.5455 26.3793L36.5909 16.9096C36.8743 16.7503 37.1939 16.6667 37.5189 16.6667C37.844 16.6667 38.1636 16.7503 38.447 16.9096L55.4924 26.3793C55.9289 26.626 56.2497 27.0356 56.3846 27.5185Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseCircle);
export default __webpack_public_path__ + "static/media/warehouse_circle.fda1f175770a5fd713ac26f2ac6a9aba.svg";
export { ForwardRef as ReactComponent };